import React, { useEffect } from "react";

const Testimonial = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);

    const hideBranding = () => {
      const badge = document.querySelector(
        'a[href*="elfsight.com/google-reviews-widget"]'
      );
      if (badge) badge.style.display = "none";
    };

    const interval = setInterval(hideBranding, 500);

    return () => {
      document.body.removeChild(script);
      clearInterval(interval);
    };
  }, []);

  return (
    <section className="py-4 bg-white px-2 px-lg-0">
      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="text-center">
            <h2 className="fw-semibold">Customer Testimonials</h2>
            <p className="d-flex justify-content-center mt-15 mb-20">
              Here's what our customers are saying about the 9R NFC Card.
              Trusted by professionals and businesses, the 9R NFC Card makes
              digital sharing seamless and stylish.
            </p>
          </div>
          <div
            className="elfsight-app-7c3d86bd-678d-43ed-b8b6-e3167d865d24"
            data-elfsight-app-lazy
          ></div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
